import {apiUrl} from "./api-methods"
import UtilsCommon from "../utils/utils.common";

function getFakeAvatarUrl(user) {
  const fakeAvatarId = (user.id % 50).toLocaleString(undefined, {minimumIntegerDigits: 2});
  return `https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/${fakeAvatarId}.png`;
}

async function getAzureAdAvatarUrl(user, accessToken) {
  const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
    headers: {Authorization: `Bearer ${accessToken}`},
  });
  const pictureBlob = await response.blob();
  return window.URL.createObjectURL(pictureBlob);
}

async function userData(user, token, optionsArg) {
  const defaultOptions = {
    fakeAvatar: true,
    azureAdAvatar: false,
    azureAdAccessToken: null,
  }
  const options = {...defaultOptions, ...optionsArg};

  let avatarUrl;
  if (options.fakeAvatar) {
    avatarUrl = getFakeAvatarUrl(user);
  } else if (options.azureAdAvatar && options.azureAdAccessToken) {
    avatarUrl = await getAzureAdAvatarUrl(user, options.azureAdAccessToken);
  }
  console.log('returning user data', {...user, token, avatarUrl}, options, optionsArg);
  return {...user, token, avatarUrl};
}

export async function signIn(email, password) {

  try {
    // Send request
    // console.log(email, password);
    const response = await window.fetch(apiUrl('user/login'), {
      method: 'POST',
      headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': true},
      body: JSON.stringify({login: email, password})
    });
    const {user, token} = await response.json();
    window.localStorage.setItem('token', token);

    return {
      isOk: true,
      data: await userData(user, token)
    };
  } catch {
    return {isOk: false, message: "Authentication failed"};
  }
}

export async function getUser() {
  const notOk = {isOk: false};
  if (!UtilsCommon.authTokenExists()) return notOk;
  try {
    const token = window.localStorage.getItem('token');
    const adAccessToken = window.localStorage.getItem('adAccessToken');
    const response = await window.fetch(apiUrl('user/me'), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'ngrok-skip-browser-warning': true
      }
    });
    const user = await response.json();
    const userDataOpts = {
      fakeAvatar: !adAccessToken,
      azureAdAvatar: !!adAccessToken,
      azureAdAccessToken: adAccessToken
    };

    return {
      isOk: true,
      data: await userData(user, token, userDataOpts)
    };
  } catch {
    return notOk;
  }
}

async function dealWithOutlookIfNecessary() {
  return new Promise((resolve, reject) => {
    // const isOutlookDialog = new URLSearchParams(window.location.search).get('outlook') === 'true';
    const isOutlookDialog = (window.location.hash || "").includes("outlook=true");
    if (!isOutlookDialog) return resolve(false);

    const script = document.createElement('script');
    script.src = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js';
    script.async = true;
    document.head.appendChild(script);

    // Wait for the script to load and the "Office" object to be available in the global scope before resolving. Wait
    // a bit for the "Office" object to be available in the global scope.
    script.onload = () => {
      let tries = 0;
      const interval = setInterval(() => {
        if (window.Office) {
          clearInterval(interval);
          resolve(true);
        } else if (tries++ > 40) {
          clearInterval(interval);
          reject('Office object not available after 100 tries');
        }
      }, 100);
    }
  });
}

/**
 * The C# model from the web server (User/ssoLoginOrRegister) is:
 * public class SSOLoginOrRegisterResponse
 * {
 *     public bool Success { get; set; }
 *     public string? Message { get; set; }
 *     public bool AlreadyRegistered { get; set; }
 *     public DbUser? User { get; set; }
 * }
 *
 * The expected request model is:
 * public class SSOLoginOrRegisterRequest
 * {
 *     public string Fullname { get; set; }
 *     public string Username { get; set; }
 *     public string AccessToken { get; set; }
 * }
 *
 * @returns {Promise<{isOk: boolean, message: string, data: any}>}
 */
export async function ssoLoginOrRegister(ssoResponse) {
  const fullname = ssoResponse.account.name;
  const username = ssoResponse.account.username;
  const accessToken = ssoResponse.accessToken;

  try {
    const response = await window.fetch(apiUrl('user/ssoLoginOrRegister'), {
      method: 'POST',
      headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': true},
      body: JSON.stringify({fullname, username, accessToken})
    });
    const {user, success, message, alreadyRegistered, builtToken} = await response.json();
    const userDataOpts = {fakeAvatar: false, azureAdAvatar: true, azureAdAccessToken: accessToken};

    window.localStorage.setItem('token', builtToken);
    window.localStorage.setItem('adAccessToken', accessToken);
    console.log('sso login or register', {user, success, message, alreadyRegistered, builtToken, accessToken});

    const outlookMatter = await dealWithOutlookIfNecessary();
    if (outlookMatter === true) window.Office.context.ui.messageParent(JSON.stringify({
      type: 'token',
      token: builtToken
    }));

    return {
      isOk: success,
      message,
      data: await userData(user, builtToken, userDataOpts)
    };
  } catch (e) {
    return {isOk: false, message: "SSO Authentication failed locally: " + e.toString()};
  }
}

export async function createAccount(email, password) {
  try {
    // Send request
    // console.log(email, password);

    return {
      isOk: true
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }
}

export async function changePassword(email, recoveryCode) {
  try {
    // Send request
    // console.log(email, recoveryCode);

    return {
      isOk: true
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email) {
  try {
    // Send request
    console.log(email);

    return {
      isOk: true
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}
